import React, { useState } from 'react';
import { InboxOutlined } from '@ant-design/icons';
import { message, Upload, Input, Button } from 'antd';
import { BASE_URL } from "../utils/constants";
import Cookie from "js-cookie";


const { Dragger } = Upload;

const DataUpload = () => {
  const [regKey, setRegKey] = useState('');
  const [canUpload, setCanUpload] = useState(false);

  const props = {
    name: 'report',
    multiple: false,
    action: `${BASE_URL}/api/reports/upload`,
    data: { key: regKey }, // 🔑 send REG_KEY with upload
    headers: {
      Authorization: `Bearer ${Cookie.get('token')}`,
    },
    onChange(info) {
        const { status, response, error } = info.file;
        if (status === 'done') {
        if (response?.success) {
            message.success(response.message || `${info.file.name} uploaded successfully.`);
        } else {
            message.error(response?.error || `${info.file.name} upload failed.`);
        }
        } else if (status === 'error') {
        // response may not exist if server crashed
        message.error(
            response?.error ||
            error?.message ||
            `${info.file.name} upload failed.`
        );
        }
    },
    beforeUpload: () => {
      if (!regKey) {
        message.error('Please enter the REG_KEY before uploading!');
        return Upload.LIST_IGNORE;
      }
      return true;
    },
    onDrop(e) {
      console.log('Dropped files', e.dataTransfer.files);
    },
  };

  return (
    <>
      <h2>Data upload zone:</h2>
      <div style={{ marginBottom: 16 }}>
        <Input.Password
          placeholder="Enter REG_KEY to unlock upload"
          value={regKey}
          onChange={(e) => setRegKey(e.target.value)}
          style={{ width: 300, marginRight: 8 }}
        />
        <Button type="primary" onClick={() => setCanUpload(true)} disabled={!regKey}>
          Unlock Upload
        </Button>
      </div>

      {canUpload && (
        <div className="both-axis-centred" style={{ width: "100%", height: "80vh" }}>
          <Dragger {...props}>
            <p className="ant-upload-drag-icon">
              <InboxOutlined />
            </p>
            <p className="ant-upload-text">Click or drag file to this area to upload</p>
            <p className="ant-upload-hint">Supported extensions: csv, xlsx</p>
            <p className="ant-upload-hint">Max. size: 20MB</p>
            <p className="ant-upload-hint">Naming convention: PlatformName-direct.xlsx or PlatformName-direct.csv</p>
          </Dragger>
        </div>
      )}
    </>
  );
};

export default DataUpload;
